export const Assets = {
    "IMG_RAYS": {
        "type": "IMAGE",
        "key": "IMG_RAYS",
        "imageUrl": "assets/images/rays.png"
    },
    "IMG_TITLE": {
        "type": "IMAGE",
        "key": "IMG_TITLE",
        "imageUrl": "assets/images/title.png"
    },
    "ATLAS_BALLOON_ICONS": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_BALLOON_ICONS",
        "imageUrl": "assets/images/balloon_icons.png",
        "jsonUrl": "assets/images/balloon_icons.json"
    },
    "ATLAS_BARN_FULL": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_BARN_FULL",
        "imageUrl": "assets/images/barn_full.png",
        "jsonUrl": "assets/images/barn_full.json"
    },
    "ATLAS_CALF1_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CALF1_IDLE",
        "imageUrl": "assets/images/calf1_idle.png",
        "jsonUrl": "assets/images/calf1_idle.json"
    },
    "ATLAS_CALF1_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CALF1_JUMP",
        "imageUrl": "assets/images/calf1_jump.png",
        "jsonUrl": "assets/images/calf1_jump.json"
    },
    "ATLAS_CALF2_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CALF2_IDLE",
        "imageUrl": "assets/images/calf2_idle.png",
        "jsonUrl": "assets/images/calf2_idle.json"
    },
    "ATLAS_CALF2_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CALF2_JUMP",
        "imageUrl": "assets/images/calf2_jump.png",
        "jsonUrl": "assets/images/calf2_jump.json"
    },
    "ATLAS_CHICKEN1_LARGE_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN1_LARGE_IDLE",
        "imageUrl": "assets/images/chicken1_large_idle.png",
        "jsonUrl": "assets/images/chicken1_large_idle.json"
    },
    "ATLAS_CHICKEN1_LARGE_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN1_LARGE_JUMP",
        "imageUrl": "assets/images/chicken1_large_jump.png",
        "jsonUrl": "assets/images/chicken1_large_jump.json"
    },
    "ATLAS_CHICKEN1_MEDIUM_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN1_MEDIUM_IDLE",
        "imageUrl": "assets/images/chicken1_medium_idle.png",
        "jsonUrl": "assets/images/chicken1_medium_idle.json"
    },
    "ATLAS_CHICKEN1_MEDIUM_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN1_MEDIUM_JUMP",
        "imageUrl": "assets/images/chicken1_medium_jump.png",
        "jsonUrl": "assets/images/chicken1_medium_jump.json"
    },
    "ATLAS_CHICKEN1_SMALL_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN1_SMALL_IDLE",
        "imageUrl": "assets/images/chicken1_small_idle.png",
        "jsonUrl": "assets/images/chicken1_small_idle.json"
    },
    "ATLAS_CHICKEN1_SMALL_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN1_SMALL_JUMP",
        "imageUrl": "assets/images/chicken1_small_jump.png",
        "jsonUrl": "assets/images/chicken1_small_jump.json"
    },
    "ATLAS_CHICKEN2_LARGE_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN2_LARGE_IDLE",
        "imageUrl": "assets/images/chicken2_large_idle.png",
        "jsonUrl": "assets/images/chicken2_large_idle.json"
    },
    "ATLAS_CHICKEN2_LARGE_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN2_LARGE_JUMP",
        "imageUrl": "assets/images/chicken2_large_jump.png",
        "jsonUrl": "assets/images/chicken2_large_jump.json"
    },
    "ATLAS_CHICKEN2_MEDIUM_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN2_MEDIUM_IDLE",
        "imageUrl": "assets/images/chicken2_medium_idle.png",
        "jsonUrl": "assets/images/chicken2_medium_idle.json"
    },
    "ATLAS_CHICKEN2_MEDIUM_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN2_MEDIUM_JUMP",
        "imageUrl": "assets/images/chicken2_medium_jump.png",
        "jsonUrl": "assets/images/chicken2_medium_jump.json"
    },
    "ATLAS_CHICKEN2_SMALL_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN2_SMALL_IDLE",
        "imageUrl": "assets/images/chicken2_small_idle.png",
        "jsonUrl": "assets/images/chicken2_small_idle.json"
    },
    "ATLAS_CHICKEN2_SMALL_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN2_SMALL_JUMP",
        "imageUrl": "assets/images/chicken2_small_jump.png",
        "jsonUrl": "assets/images/chicken2_small_jump.json"
    },
    "ATLAS_CHICKEN3_LARGE_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN3_LARGE_IDLE",
        "imageUrl": "assets/images/chicken3_large_idle.png",
        "jsonUrl": "assets/images/chicken3_large_idle.json"
    },
    "ATLAS_CHICKEN3_LARGE_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN3_LARGE_JUMP",
        "imageUrl": "assets/images/chicken3_large_jump.png",
        "jsonUrl": "assets/images/chicken3_large_jump.json"
    },
    "ATLAS_CHICKEN3_MEDIUM_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN3_MEDIUM_IDLE",
        "imageUrl": "assets/images/chicken3_medium_idle.png",
        "jsonUrl": "assets/images/chicken3_medium_idle.json"
    },
    "ATLAS_CHICKEN3_MEDIUM_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN3_MEDIUM_JUMP",
        "imageUrl": "assets/images/chicken3_medium_jump.png",
        "jsonUrl": "assets/images/chicken3_medium_jump.json"
    },
    "ATLAS_CHICKEN3_SMALL_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN3_SMALL_IDLE",
        "imageUrl": "assets/images/chicken3_small_idle.png",
        "jsonUrl": "assets/images/chicken3_small_idle.json"
    },
    "ATLAS_CHICKEN3_SMALL_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CHICKEN3_SMALL_JUMP",
        "imageUrl": "assets/images/chicken3_small_jump.png",
        "jsonUrl": "assets/images/chicken3_small_jump.json"
    },
    "ATLAS_COW1_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_COW1_IDLE",
        "imageUrl": "assets/images/cow1_idle.png",
        "jsonUrl": "assets/images/cow1_idle.json"
    },
    "ATLAS_COW1_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_COW1_JUMP",
        "imageUrl": "assets/images/cow1_jump.png",
        "jsonUrl": "assets/images/cow1_jump.json"
    },
    "ATLAS_COW2_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_COW2_IDLE",
        "imageUrl": "assets/images/cow2_idle.png",
        "jsonUrl": "assets/images/cow2_idle.json"
    },
    "ATLAS_COW2_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_COW2_JUMP",
        "imageUrl": "assets/images/cow2_jump.png",
        "jsonUrl": "assets/images/cow2_jump.json"
    },
    "ATLAS_GAME": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_GAME",
        "imageUrl": "assets/images/game.png",
        "jsonUrl": "assets/images/game.json"
    },
    "ATLAS_GOAT1_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_GOAT1_IDLE",
        "imageUrl": "assets/images/goat1_idle.png",
        "jsonUrl": "assets/images/goat1_idle.json"
    },
    "ATLAS_GOAT1_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_GOAT1_JUMP",
        "imageUrl": "assets/images/goat1_jump.png",
        "jsonUrl": "assets/images/goat1_jump.json"
    },
    "ATLAS_GOAT2_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_GOAT2_IDLE",
        "imageUrl": "assets/images/goat2_idle.png",
        "jsonUrl": "assets/images/goat2_idle.json"
    },
    "ATLAS_GOAT2_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_GOAT2_JUMP",
        "imageUrl": "assets/images/goat2_jump.png",
        "jsonUrl": "assets/images/goat2_jump.json"
    },
    "ATLAS_HELPER_WALK": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HELPER_WALK",
        "imageUrl": "assets/images/helper_walk.png",
        "jsonUrl": "assets/images/helper_walk.json"
    },
    "ATLAS_KID1_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_KID1_IDLE",
        "imageUrl": "assets/images/kid1_idle.png",
        "jsonUrl": "assets/images/kid1_idle.json"
    },
    "ATLAS_KID1_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_KID1_JUMP",
        "imageUrl": "assets/images/kid1_jump.png",
        "jsonUrl": "assets/images/kid1_jump.json"
    },
    "ATLAS_KID2_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_KID2_IDLE",
        "imageUrl": "assets/images/kid2_idle.png",
        "jsonUrl": "assets/images/kid2_idle.json"
    },
    "ATLAS_KID2_JUMP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_KID2_JUMP",
        "imageUrl": "assets/images/kid2_jump.png",
        "jsonUrl": "assets/images/kid2_jump.json"
    },
    "ATLAS_LOADER": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_LOADER",
        "imageUrl": "assets/images/loader.png",
        "jsonUrl": "assets/images/loader.json"
    },
    "ATLAS_LOW_HEALTH_EFFECT": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_LOW_HEALTH_EFFECT",
        "imageUrl": "assets/images/low_health_effect.png",
        "jsonUrl": "assets/images/low_health_effect.json"
    },
    "ATLAS_POINTER": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_POINTER",
        "imageUrl": "assets/images/pointer.png",
        "jsonUrl": "assets/images/pointer.json"
    },
    "ATLAS_TILESET": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_TILESET",
        "imageUrl": "assets/images/tileset.png",
        "jsonUrl": "assets/images/tileset.json"
    },
    "ATLAS_UI": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_UI",
        "imageUrl": "assets/images/ui.png",
        "jsonUrl": "assets/images/ui.json"
    },
    "FRAME_BALLOON_ICONS_BARN_ICON": "barn_icon",
    "FRAME_BALLOON_ICONS_CHICKEN1_SMALL_ICON": "chicken1_small_icon",
    "FRAME_BALLOON_ICONS_CHICKEN2_SMALL_ICON": "chicken2_small_icon",
    "FRAME_BALLOON_ICONS_CHICKEN3_SMALL_ICON": "chicken3_small_icon",
    "FRAME_BALLOON_ICONS_COW1_ICON2": "cow1_icon2",
    "FRAME_BALLOON_ICONS_COW2_ICON2": "cow2_icon2",
    "FRAME_BALLOON_ICONS_FARM_ICON": "farm_icon",
    "FRAME_BALLOON_ICONS_FOODPOT_ICON": "foodpot_icon",
    "FRAME_BALLOON_ICONS_GOAT1_ICON2": "goat1_icon2",
    "FRAME_BALLOON_ICONS_GOAT2_ICON2": "goat2_icon2",
    "FRAME_BALLOON_ICONS_HELPER_ICON": "helper_icon",
    "FRAME_BALLOON_ICONS_MANAGER_ICON": "manager_icon",
    "FRAME_BALLOON_ICONS_WATERPOT_ICON": "waterpot_icon",
    "FRAME_BARN_FULL_BARN_FULL_01": "barn_full_01",
    "FRAME_BARN_FULL_BARN_FULL_03": "barn_full_03",
    "FRAME_BARN_FULL_BARN_FULL_04": "barn_full_04",
    "FRAME_BARN_FULL_BARN_FULL_05": "barn_full_05",
    "FRAME_BARN_FULL_BARN_FULL_06": "barn_full_06",
    "FRAME_BARN_FULL_BARN_FULL_02": "barn_full_02",
    "FRAME_BARN_FULL_BARN_FULL_07": "barn_full_07",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0000": "calf1-idle_0000",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0001": "calf1-idle_0001",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0002": "calf1-idle_0002",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0003": "calf1-idle_0003",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0004": "calf1-idle_0004",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0005": "calf1-idle_0005",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0006": "calf1-idle_0006",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0007": "calf1-idle_0007",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0008": "calf1-idle_0008",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0009": "calf1-idle_0009",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0010": "calf1-idle_0010",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0012": "calf1-idle_0012",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0013": "calf1-idle_0013",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0014": "calf1-idle_0014",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0019": "calf1-idle_0019",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0018": "calf1-idle_0018",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0017": "calf1-idle_0017",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0016": "calf1-idle_0016",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0015": "calf1-idle_0015",
    "FRAME_CALF1_IDLE_CALF1_IDLE_0011": "calf1-idle_0011",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0000": "calf1-jump_0000",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0001": "calf1-jump_0001",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0002": "calf1-jump_0002",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0003": "calf1-jump_0003",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0004": "calf1-jump_0004",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0005": "calf1-jump_0005",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0006": "calf1-jump_0006",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0007": "calf1-jump_0007",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0008": "calf1-jump_0008",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0009": "calf1-jump_0009",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0010": "calf1-jump_0010",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0012": "calf1-jump_0012",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0013": "calf1-jump_0013",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0014": "calf1-jump_0014",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0015": "calf1-jump_0015",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0019": "calf1-jump_0019",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0018": "calf1-jump_0018",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0017": "calf1-jump_0017",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0016": "calf1-jump_0016",
    "FRAME_CALF1_JUMP_CALF1_JUMP_0011": "calf1-jump_0011",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0000": "calf2-idle_0000",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0001": "calf2-idle_0001",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0002": "calf2-idle_0002",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0003": "calf2-idle_0003",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0004": "calf2-idle_0004",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0005": "calf2-idle_0005",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0006": "calf2-idle_0006",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0007": "calf2-idle_0007",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0008": "calf2-idle_0008",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0009": "calf2-idle_0009",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0010": "calf2-idle_0010",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0012": "calf2-idle_0012",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0013": "calf2-idle_0013",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0014": "calf2-idle_0014",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0019": "calf2-idle_0019",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0018": "calf2-idle_0018",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0017": "calf2-idle_0017",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0016": "calf2-idle_0016",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0015": "calf2-idle_0015",
    "FRAME_CALF2_IDLE_CALF2_IDLE_0011": "calf2-idle_0011",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0000": "calf2-jump_0000",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0001": "calf2-jump_0001",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0002": "calf2-jump_0002",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0003": "calf2-jump_0003",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0004": "calf2-jump_0004",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0005": "calf2-jump_0005",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0006": "calf2-jump_0006",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0007": "calf2-jump_0007",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0008": "calf2-jump_0008",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0009": "calf2-jump_0009",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0010": "calf2-jump_0010",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0012": "calf2-jump_0012",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0013": "calf2-jump_0013",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0014": "calf2-jump_0014",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0015": "calf2-jump_0015",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0017": "calf2-jump_0017",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0019": "calf2-jump_0019",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0018": "calf2-jump_0018",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0016": "calf2-jump_0016",
    "FRAME_CALF2_JUMP_CALF2_JUMP_0011": "calf2-jump_0011",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0001": "chicken1_large_idle_0001",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0002": "chicken1_large_idle_0002",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0003": "chicken1_large_idle_0003",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0004": "chicken1_large_idle_0004",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0005": "chicken1_large_idle_0005",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0006": "chicken1_large_idle_0006",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0007": "chicken1_large_idle_0007",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0008": "chicken1_large_idle_0008",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0009": "chicken1_large_idle_0009",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0010": "chicken1_large_idle_0010",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0011": "chicken1_large_idle_0011",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0012": "chicken1_large_idle_0012",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0013": "chicken1_large_idle_0013",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0014": "chicken1_large_idle_0014",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0015": "chicken1_large_idle_0015",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0016": "chicken1_large_idle_0016",
    "FRAME_CHICKEN1_LARGE_IDLE_CHICKEN1_LARGE_IDLE_0017": "chicken1_large_idle_0017",
    "FRAME_CHICKEN1_LARGE_JUMP_CHICKEN1_LARGE_JUMP_0001": "chicken1_large_jump_0001",
    "FRAME_CHICKEN1_LARGE_JUMP_CHICKEN1_LARGE_JUMP_0002": "chicken1_large_jump_0002",
    "FRAME_CHICKEN1_LARGE_JUMP_CHICKEN1_LARGE_JUMP_0003": "chicken1_large_jump_0003",
    "FRAME_CHICKEN1_LARGE_JUMP_CHICKEN1_LARGE_JUMP_0004": "chicken1_large_jump_0004",
    "FRAME_CHICKEN1_LARGE_JUMP_CHICKEN1_LARGE_JUMP_0005": "chicken1_large_jump_0005",
    "FRAME_CHICKEN1_LARGE_JUMP_CHICKEN1_LARGE_JUMP_0006": "chicken1_large_jump_0006",
    "FRAME_CHICKEN1_LARGE_JUMP_CHICKEN1_LARGE_JUMP_0007": "chicken1_large_jump_0007",
    "FRAME_CHICKEN1_LARGE_JUMP_CHICKEN1_LARGE_JUMP_0008": "chicken1_large_jump_0008",
    "FRAME_CHICKEN1_LARGE_JUMP_CHICKEN1_LARGE_JUMP_0009": "chicken1_large_jump_0009",
    "FRAME_CHICKEN1_LARGE_JUMP_CHICKEN1_LARGE_JUMP_0010": "chicken1_large_jump_0010",
    "FRAME_CHICKEN1_LARGE_JUMP_CHICKEN1_LARGE_JUMP_0011": "chicken1_large_jump_0011",
    "FRAME_CHICKEN1_LARGE_JUMP_CHICKEN1_LARGE_JUMP_0012": "chicken1_large_jump_0012",
    "FRAME_CHICKEN1_LARGE_JUMP_CHICKEN1_LARGE_JUMP_0013": "chicken1_large_jump_0013",
    "FRAME_CHICKEN1_LARGE_JUMP_CHICKEN1_LARGE_JUMP_0014": "chicken1_large_jump_0014",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0001": "chicken1_medium_idle_0001",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0002": "chicken1_medium_idle_0002",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0003": "chicken1_medium_idle_0003",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0004": "chicken1_medium_idle_0004",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0005": "chicken1_medium_idle_0005",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0006": "chicken1_medium_idle_0006",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0007": "chicken1_medium_idle_0007",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0008": "chicken1_medium_idle_0008",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0009": "chicken1_medium_idle_0009",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0010": "chicken1_medium_idle_0010",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0011": "chicken1_medium_idle_0011",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0012": "chicken1_medium_idle_0012",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0013": "chicken1_medium_idle_0013",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0014": "chicken1_medium_idle_0014",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0015": "chicken1_medium_idle_0015",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0016": "chicken1_medium_idle_0016",
    "FRAME_CHICKEN1_MEDIUM_IDLE_CHICKEN1_MEDIUM_IDLE_0017": "chicken1_medium_idle_0017",
    "FRAME_CHICKEN1_MEDIUM_JUMP_CHICKEN1_MEDIUM_JUMP_0001": "chicken1_medium_jump_0001",
    "FRAME_CHICKEN1_MEDIUM_JUMP_CHICKEN1_MEDIUM_JUMP_0002": "chicken1_medium_jump_0002",
    "FRAME_CHICKEN1_MEDIUM_JUMP_CHICKEN1_MEDIUM_JUMP_0003": "chicken1_medium_jump_0003",
    "FRAME_CHICKEN1_MEDIUM_JUMP_CHICKEN1_MEDIUM_JUMP_0004": "chicken1_medium_jump_0004",
    "FRAME_CHICKEN1_MEDIUM_JUMP_CHICKEN1_MEDIUM_JUMP_0005": "chicken1_medium_jump_0005",
    "FRAME_CHICKEN1_MEDIUM_JUMP_CHICKEN1_MEDIUM_JUMP_0006": "chicken1_medium_jump_0006",
    "FRAME_CHICKEN1_MEDIUM_JUMP_CHICKEN1_MEDIUM_JUMP_0007": "chicken1_medium_jump_0007",
    "FRAME_CHICKEN1_MEDIUM_JUMP_CHICKEN1_MEDIUM_JUMP_0008": "chicken1_medium_jump_0008",
    "FRAME_CHICKEN1_MEDIUM_JUMP_CHICKEN1_MEDIUM_JUMP_0009": "chicken1_medium_jump_0009",
    "FRAME_CHICKEN1_MEDIUM_JUMP_CHICKEN1_MEDIUM_JUMP_0011": "chicken1_medium_jump_0011",
    "FRAME_CHICKEN1_MEDIUM_JUMP_CHICKEN1_MEDIUM_JUMP_0012": "chicken1_medium_jump_0012",
    "FRAME_CHICKEN1_MEDIUM_JUMP_CHICKEN1_MEDIUM_JUMP_0013": "chicken1_medium_jump_0013",
    "FRAME_CHICKEN1_MEDIUM_JUMP_CHICKEN1_MEDIUM_JUMP_0014": "chicken1_medium_jump_0014",
    "FRAME_CHICKEN1_MEDIUM_JUMP_CHICKEN1_MEDIUM_JUMP_0010": "chicken1_medium_jump_0010",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0001": "chicken1_small_idle_0001",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0002": "chicken1_small_idle_0002",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0003": "chicken1_small_idle_0003",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0004": "chicken1_small_idle_0004",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0005": "chicken1_small_idle_0005",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0006": "chicken1_small_idle_0006",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0007": "chicken1_small_idle_0007",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0008": "chicken1_small_idle_0008",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0009": "chicken1_small_idle_0009",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0010": "chicken1_small_idle_0010",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0011": "chicken1_small_idle_0011",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0012": "chicken1_small_idle_0012",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0013": "chicken1_small_idle_0013",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0014": "chicken1_small_idle_0014",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0015": "chicken1_small_idle_0015",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0016": "chicken1_small_idle_0016",
    "FRAME_CHICKEN1_SMALL_IDLE_CHICKEN1_SMALL_IDLE_0017": "chicken1_small_idle_0017",
    "FRAME_CHICKEN1_SMALL_JUMP_CHICKEN1_SMALL_JUMP_0001": "chicken1_small_jump_0001",
    "FRAME_CHICKEN1_SMALL_JUMP_CHICKEN1_SMALL_JUMP_0002": "chicken1_small_jump_0002",
    "FRAME_CHICKEN1_SMALL_JUMP_CHICKEN1_SMALL_JUMP_0003": "chicken1_small_jump_0003",
    "FRAME_CHICKEN1_SMALL_JUMP_CHICKEN1_SMALL_JUMP_0004": "chicken1_small_jump_0004",
    "FRAME_CHICKEN1_SMALL_JUMP_CHICKEN1_SMALL_JUMP_0005": "chicken1_small_jump_0005",
    "FRAME_CHICKEN1_SMALL_JUMP_CHICKEN1_SMALL_JUMP_0006": "chicken1_small_jump_0006",
    "FRAME_CHICKEN1_SMALL_JUMP_CHICKEN1_SMALL_JUMP_0007": "chicken1_small_jump_0007",
    "FRAME_CHICKEN1_SMALL_JUMP_CHICKEN1_SMALL_JUMP_0008": "chicken1_small_jump_0008",
    "FRAME_CHICKEN1_SMALL_JUMP_CHICKEN1_SMALL_JUMP_0009": "chicken1_small_jump_0009",
    "FRAME_CHICKEN1_SMALL_JUMP_CHICKEN1_SMALL_JUMP_0011": "chicken1_small_jump_0011",
    "FRAME_CHICKEN1_SMALL_JUMP_CHICKEN1_SMALL_JUMP_0012": "chicken1_small_jump_0012",
    "FRAME_CHICKEN1_SMALL_JUMP_CHICKEN1_SMALL_JUMP_0013": "chicken1_small_jump_0013",
    "FRAME_CHICKEN1_SMALL_JUMP_CHICKEN1_SMALL_JUMP_0014": "chicken1_small_jump_0014",
    "FRAME_CHICKEN1_SMALL_JUMP_CHICKEN1_SMALL_JUMP_0010": "chicken1_small_jump_0010",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0001": "chicken2_large_idle_0001",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0002": "chicken2_large_idle_0002",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0003": "chicken2_large_idle_0003",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0004": "chicken2_large_idle_0004",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0005": "chicken2_large_idle_0005",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0006": "chicken2_large_idle_0006",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0007": "chicken2_large_idle_0007",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0008": "chicken2_large_idle_0008",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0009": "chicken2_large_idle_0009",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0010": "chicken2_large_idle_0010",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0011": "chicken2_large_idle_0011",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0012": "chicken2_large_idle_0012",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0013": "chicken2_large_idle_0013",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0014": "chicken2_large_idle_0014",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0015": "chicken2_large_idle_0015",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0016": "chicken2_large_idle_0016",
    "FRAME_CHICKEN2_LARGE_IDLE_CHICKEN2_LARGE_IDLE_0017": "chicken2_large_idle_0017",
    "FRAME_CHICKEN2_LARGE_JUMP_CHICKEN2_LARGE_JUMP_0001": "chicken2_large_jump_0001",
    "FRAME_CHICKEN2_LARGE_JUMP_CHICKEN2_LARGE_JUMP_0002": "chicken2_large_jump_0002",
    "FRAME_CHICKEN2_LARGE_JUMP_CHICKEN2_LARGE_JUMP_0003": "chicken2_large_jump_0003",
    "FRAME_CHICKEN2_LARGE_JUMP_CHICKEN2_LARGE_JUMP_0004": "chicken2_large_jump_0004",
    "FRAME_CHICKEN2_LARGE_JUMP_CHICKEN2_LARGE_JUMP_0005": "chicken2_large_jump_0005",
    "FRAME_CHICKEN2_LARGE_JUMP_CHICKEN2_LARGE_JUMP_0006": "chicken2_large_jump_0006",
    "FRAME_CHICKEN2_LARGE_JUMP_CHICKEN2_LARGE_JUMP_0007": "chicken2_large_jump_0007",
    "FRAME_CHICKEN2_LARGE_JUMP_CHICKEN2_LARGE_JUMP_0008": "chicken2_large_jump_0008",
    "FRAME_CHICKEN2_LARGE_JUMP_CHICKEN2_LARGE_JUMP_0009": "chicken2_large_jump_0009",
    "FRAME_CHICKEN2_LARGE_JUMP_CHICKEN2_LARGE_JUMP_0010": "chicken2_large_jump_0010",
    "FRAME_CHICKEN2_LARGE_JUMP_CHICKEN2_LARGE_JUMP_0011": "chicken2_large_jump_0011",
    "FRAME_CHICKEN2_LARGE_JUMP_CHICKEN2_LARGE_JUMP_0012": "chicken2_large_jump_0012",
    "FRAME_CHICKEN2_LARGE_JUMP_CHICKEN2_LARGE_JUMP_0013": "chicken2_large_jump_0013",
    "FRAME_CHICKEN2_LARGE_JUMP_CHICKEN2_LARGE_JUMP_0014": "chicken2_large_jump_0014",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0001": "chicken2_medium_idle_0001",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0002": "chicken2_medium_idle_0002",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0003": "chicken2_medium_idle_0003",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0004": "chicken2_medium_idle_0004",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0005": "chicken2_medium_idle_0005",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0006": "chicken2_medium_idle_0006",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0007": "chicken2_medium_idle_0007",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0008": "chicken2_medium_idle_0008",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0009": "chicken2_medium_idle_0009",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0010": "chicken2_medium_idle_0010",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0011": "chicken2_medium_idle_0011",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0012": "chicken2_medium_idle_0012",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0013": "chicken2_medium_idle_0013",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0014": "chicken2_medium_idle_0014",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0015": "chicken2_medium_idle_0015",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0016": "chicken2_medium_idle_0016",
    "FRAME_CHICKEN2_MEDIUM_IDLE_CHICKEN2_MEDIUM_IDLE_0017": "chicken2_medium_idle_0017",
    "FRAME_CHICKEN2_MEDIUM_JUMP_CHICKEN2_MEDIUM_JUMP_0001": "chicken2_medium_jump_0001",
    "FRAME_CHICKEN2_MEDIUM_JUMP_CHICKEN2_MEDIUM_JUMP_0002": "chicken2_medium_jump_0002",
    "FRAME_CHICKEN2_MEDIUM_JUMP_CHICKEN2_MEDIUM_JUMP_0003": "chicken2_medium_jump_0003",
    "FRAME_CHICKEN2_MEDIUM_JUMP_CHICKEN2_MEDIUM_JUMP_0004": "chicken2_medium_jump_0004",
    "FRAME_CHICKEN2_MEDIUM_JUMP_CHICKEN2_MEDIUM_JUMP_0005": "chicken2_medium_jump_0005",
    "FRAME_CHICKEN2_MEDIUM_JUMP_CHICKEN2_MEDIUM_JUMP_0006": "chicken2_medium_jump_0006",
    "FRAME_CHICKEN2_MEDIUM_JUMP_CHICKEN2_MEDIUM_JUMP_0007": "chicken2_medium_jump_0007",
    "FRAME_CHICKEN2_MEDIUM_JUMP_CHICKEN2_MEDIUM_JUMP_0008": "chicken2_medium_jump_0008",
    "FRAME_CHICKEN2_MEDIUM_JUMP_CHICKEN2_MEDIUM_JUMP_0009": "chicken2_medium_jump_0009",
    "FRAME_CHICKEN2_MEDIUM_JUMP_CHICKEN2_MEDIUM_JUMP_0011": "chicken2_medium_jump_0011",
    "FRAME_CHICKEN2_MEDIUM_JUMP_CHICKEN2_MEDIUM_JUMP_0012": "chicken2_medium_jump_0012",
    "FRAME_CHICKEN2_MEDIUM_JUMP_CHICKEN2_MEDIUM_JUMP_0013": "chicken2_medium_jump_0013",
    "FRAME_CHICKEN2_MEDIUM_JUMP_CHICKEN2_MEDIUM_JUMP_0014": "chicken2_medium_jump_0014",
    "FRAME_CHICKEN2_MEDIUM_JUMP_CHICKEN2_MEDIUM_JUMP_0010": "chicken2_medium_jump_0010",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0001": "chicken2_small_idle_0001",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0002": "chicken2_small_idle_0002",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0003": "chicken2_small_idle_0003",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0004": "chicken2_small_idle_0004",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0005": "chicken2_small_idle_0005",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0006": "chicken2_small_idle_0006",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0007": "chicken2_small_idle_0007",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0008": "chicken2_small_idle_0008",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0009": "chicken2_small_idle_0009",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0010": "chicken2_small_idle_0010",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0011": "chicken2_small_idle_0011",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0012": "chicken2_small_idle_0012",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0013": "chicken2_small_idle_0013",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0014": "chicken2_small_idle_0014",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0015": "chicken2_small_idle_0015",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0016": "chicken2_small_idle_0016",
    "FRAME_CHICKEN2_SMALL_IDLE_CHICKEN2_SMALL_IDLE_0017": "chicken2_small_idle_0017",
    "FRAME_CHICKEN2_SMALL_JUMP_CHICKEN2_SMALL_JUMP_0001": "chicken2_small_jump_0001",
    "FRAME_CHICKEN2_SMALL_JUMP_CHICKEN2_SMALL_JUMP_0002": "chicken2_small_jump_0002",
    "FRAME_CHICKEN2_SMALL_JUMP_CHICKEN2_SMALL_JUMP_0003": "chicken2_small_jump_0003",
    "FRAME_CHICKEN2_SMALL_JUMP_CHICKEN2_SMALL_JUMP_0004": "chicken2_small_jump_0004",
    "FRAME_CHICKEN2_SMALL_JUMP_CHICKEN2_SMALL_JUMP_0005": "chicken2_small_jump_0005",
    "FRAME_CHICKEN2_SMALL_JUMP_CHICKEN2_SMALL_JUMP_0006": "chicken2_small_jump_0006",
    "FRAME_CHICKEN2_SMALL_JUMP_CHICKEN2_SMALL_JUMP_0007": "chicken2_small_jump_0007",
    "FRAME_CHICKEN2_SMALL_JUMP_CHICKEN2_SMALL_JUMP_0008": "chicken2_small_jump_0008",
    "FRAME_CHICKEN2_SMALL_JUMP_CHICKEN2_SMALL_JUMP_0009": "chicken2_small_jump_0009",
    "FRAME_CHICKEN2_SMALL_JUMP_CHICKEN2_SMALL_JUMP_0011": "chicken2_small_jump_0011",
    "FRAME_CHICKEN2_SMALL_JUMP_CHICKEN2_SMALL_JUMP_0012": "chicken2_small_jump_0012",
    "FRAME_CHICKEN2_SMALL_JUMP_CHICKEN2_SMALL_JUMP_0013": "chicken2_small_jump_0013",
    "FRAME_CHICKEN2_SMALL_JUMP_CHICKEN2_SMALL_JUMP_0014": "chicken2_small_jump_0014",
    "FRAME_CHICKEN2_SMALL_JUMP_CHICKEN2_SMALL_JUMP_0010": "chicken2_small_jump_0010",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0001": "chicken3_large_idle_0001",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0002": "chicken3_large_idle_0002",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0003": "chicken3_large_idle_0003",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0004": "chicken3_large_idle_0004",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0005": "chicken3_large_idle_0005",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0006": "chicken3_large_idle_0006",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0007": "chicken3_large_idle_0007",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0008": "chicken3_large_idle_0008",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0009": "chicken3_large_idle_0009",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0010": "chicken3_large_idle_0010",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0011": "chicken3_large_idle_0011",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0012": "chicken3_large_idle_0012",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0013": "chicken3_large_idle_0013",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0014": "chicken3_large_idle_0014",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0015": "chicken3_large_idle_0015",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0016": "chicken3_large_idle_0016",
    "FRAME_CHICKEN3_LARGE_IDLE_CHICKEN3_LARGE_IDLE_0017": "chicken3_large_idle_0017",
    "FRAME_CHICKEN3_LARGE_JUMP_CHICKEN3_LARGE_JUMP_0001": "chicken3_large_jump_0001",
    "FRAME_CHICKEN3_LARGE_JUMP_CHICKEN3_LARGE_JUMP_0002": "chicken3_large_jump_0002",
    "FRAME_CHICKEN3_LARGE_JUMP_CHICKEN3_LARGE_JUMP_0003": "chicken3_large_jump_0003",
    "FRAME_CHICKEN3_LARGE_JUMP_CHICKEN3_LARGE_JUMP_0004": "chicken3_large_jump_0004",
    "FRAME_CHICKEN3_LARGE_JUMP_CHICKEN3_LARGE_JUMP_0005": "chicken3_large_jump_0005",
    "FRAME_CHICKEN3_LARGE_JUMP_CHICKEN3_LARGE_JUMP_0006": "chicken3_large_jump_0006",
    "FRAME_CHICKEN3_LARGE_JUMP_CHICKEN3_LARGE_JUMP_0007": "chicken3_large_jump_0007",
    "FRAME_CHICKEN3_LARGE_JUMP_CHICKEN3_LARGE_JUMP_0008": "chicken3_large_jump_0008",
    "FRAME_CHICKEN3_LARGE_JUMP_CHICKEN3_LARGE_JUMP_0009": "chicken3_large_jump_0009",
    "FRAME_CHICKEN3_LARGE_JUMP_CHICKEN3_LARGE_JUMP_0010": "chicken3_large_jump_0010",
    "FRAME_CHICKEN3_LARGE_JUMP_CHICKEN3_LARGE_JUMP_0011": "chicken3_large_jump_0011",
    "FRAME_CHICKEN3_LARGE_JUMP_CHICKEN3_LARGE_JUMP_0012": "chicken3_large_jump_0012",
    "FRAME_CHICKEN3_LARGE_JUMP_CHICKEN3_LARGE_JUMP_0013": "chicken3_large_jump_0013",
    "FRAME_CHICKEN3_LARGE_JUMP_CHICKEN3_LARGE_JUMP_0014": "chicken3_large_jump_0014",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0001": "chicken3_medium_idle_0001",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0002": "chicken3_medium_idle_0002",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0003": "chicken3_medium_idle_0003",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0004": "chicken3_medium_idle_0004",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0005": "chicken3_medium_idle_0005",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0006": "chicken3_medium_idle_0006",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0007": "chicken3_medium_idle_0007",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0008": "chicken3_medium_idle_0008",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0009": "chicken3_medium_idle_0009",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0010": "chicken3_medium_idle_0010",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0011": "chicken3_medium_idle_0011",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0012": "chicken3_medium_idle_0012",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0013": "chicken3_medium_idle_0013",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0014": "chicken3_medium_idle_0014",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0015": "chicken3_medium_idle_0015",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0016": "chicken3_medium_idle_0016",
    "FRAME_CHICKEN3_MEDIUM_IDLE_CHICKEN3_MEDIUM_IDLE_0017": "chicken3_medium_idle_0017",
    "FRAME_CHICKEN3_MEDIUM_JUMP_CHICKEN3_MEDIUM_JUMP_0001": "chicken3_medium_jump_0001",
    "FRAME_CHICKEN3_MEDIUM_JUMP_CHICKEN3_MEDIUM_JUMP_0002": "chicken3_medium_jump_0002",
    "FRAME_CHICKEN3_MEDIUM_JUMP_CHICKEN3_MEDIUM_JUMP_0003": "chicken3_medium_jump_0003",
    "FRAME_CHICKEN3_MEDIUM_JUMP_CHICKEN3_MEDIUM_JUMP_0004": "chicken3_medium_jump_0004",
    "FRAME_CHICKEN3_MEDIUM_JUMP_CHICKEN3_MEDIUM_JUMP_0005": "chicken3_medium_jump_0005",
    "FRAME_CHICKEN3_MEDIUM_JUMP_CHICKEN3_MEDIUM_JUMP_0006": "chicken3_medium_jump_0006",
    "FRAME_CHICKEN3_MEDIUM_JUMP_CHICKEN3_MEDIUM_JUMP_0007": "chicken3_medium_jump_0007",
    "FRAME_CHICKEN3_MEDIUM_JUMP_CHICKEN3_MEDIUM_JUMP_0008": "chicken3_medium_jump_0008",
    "FRAME_CHICKEN3_MEDIUM_JUMP_CHICKEN3_MEDIUM_JUMP_0009": "chicken3_medium_jump_0009",
    "FRAME_CHICKEN3_MEDIUM_JUMP_CHICKEN3_MEDIUM_JUMP_0011": "chicken3_medium_jump_0011",
    "FRAME_CHICKEN3_MEDIUM_JUMP_CHICKEN3_MEDIUM_JUMP_0012": "chicken3_medium_jump_0012",
    "FRAME_CHICKEN3_MEDIUM_JUMP_CHICKEN3_MEDIUM_JUMP_0013": "chicken3_medium_jump_0013",
    "FRAME_CHICKEN3_MEDIUM_JUMP_CHICKEN3_MEDIUM_JUMP_0014": "chicken3_medium_jump_0014",
    "FRAME_CHICKEN3_MEDIUM_JUMP_CHICKEN3_MEDIUM_JUMP_0010": "chicken3_medium_jump_0010",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0001": "chicken3_small_idle_0001",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0002": "chicken3_small_idle_0002",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0003": "chicken3_small_idle_0003",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0004": "chicken3_small_idle_0004",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0005": "chicken3_small_idle_0005",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0006": "chicken3_small_idle_0006",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0007": "chicken3_small_idle_0007",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0008": "chicken3_small_idle_0008",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0009": "chicken3_small_idle_0009",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0010": "chicken3_small_idle_0010",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0011": "chicken3_small_idle_0011",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0012": "chicken3_small_idle_0012",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0013": "chicken3_small_idle_0013",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0014": "chicken3_small_idle_0014",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0015": "chicken3_small_idle_0015",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0016": "chicken3_small_idle_0016",
    "FRAME_CHICKEN3_SMALL_IDLE_CHICKEN3_SMALL_IDLE_0017": "chicken3_small_idle_0017",
    "FRAME_CHICKEN3_SMALL_JUMP_CHICKEN3_SMALL_JUMP_0001": "chicken3_small_jump_0001",
    "FRAME_CHICKEN3_SMALL_JUMP_CHICKEN3_SMALL_JUMP_0002": "chicken3_small_jump_0002",
    "FRAME_CHICKEN3_SMALL_JUMP_CHICKEN3_SMALL_JUMP_0003": "chicken3_small_jump_0003",
    "FRAME_CHICKEN3_SMALL_JUMP_CHICKEN3_SMALL_JUMP_0004": "chicken3_small_jump_0004",
    "FRAME_CHICKEN3_SMALL_JUMP_CHICKEN3_SMALL_JUMP_0005": "chicken3_small_jump_0005",
    "FRAME_CHICKEN3_SMALL_JUMP_CHICKEN3_SMALL_JUMP_0006": "chicken3_small_jump_0006",
    "FRAME_CHICKEN3_SMALL_JUMP_CHICKEN3_SMALL_JUMP_0007": "chicken3_small_jump_0007",
    "FRAME_CHICKEN3_SMALL_JUMP_CHICKEN3_SMALL_JUMP_0008": "chicken3_small_jump_0008",
    "FRAME_CHICKEN3_SMALL_JUMP_CHICKEN3_SMALL_JUMP_0009": "chicken3_small_jump_0009",
    "FRAME_CHICKEN3_SMALL_JUMP_CHICKEN3_SMALL_JUMP_0011": "chicken3_small_jump_0011",
    "FRAME_CHICKEN3_SMALL_JUMP_CHICKEN3_SMALL_JUMP_0012": "chicken3_small_jump_0012",
    "FRAME_CHICKEN3_SMALL_JUMP_CHICKEN3_SMALL_JUMP_0013": "chicken3_small_jump_0013",
    "FRAME_CHICKEN3_SMALL_JUMP_CHICKEN3_SMALL_JUMP_0014": "chicken3_small_jump_0014",
    "FRAME_CHICKEN3_SMALL_JUMP_CHICKEN3_SMALL_JUMP_0010": "chicken3_small_jump_0010",
    "FRAME_COW1_IDLE_COW1_IDLE_0000": "cow1-idle_0000",
    "FRAME_COW1_IDLE_COW1_IDLE_0001": "cow1-idle_0001",
    "FRAME_COW1_IDLE_COW1_IDLE_0002": "cow1-idle_0002",
    "FRAME_COW1_IDLE_COW1_IDLE_0003": "cow1-idle_0003",
    "FRAME_COW1_IDLE_COW1_IDLE_0004": "cow1-idle_0004",
    "FRAME_COW1_IDLE_COW1_IDLE_0005": "cow1-idle_0005",
    "FRAME_COW1_IDLE_COW1_IDLE_0006": "cow1-idle_0006",
    "FRAME_COW1_IDLE_COW1_IDLE_0007": "cow1-idle_0007",
    "FRAME_COW1_IDLE_COW1_IDLE_0008": "cow1-idle_0008",
    "FRAME_COW1_IDLE_COW1_IDLE_0009": "cow1-idle_0009",
    "FRAME_COW1_IDLE_COW1_IDLE_0010": "cow1-idle_0010",
    "FRAME_COW1_IDLE_COW1_IDLE_0015": "cow1-idle_0015",
    "FRAME_COW1_IDLE_COW1_IDLE_0016": "cow1-idle_0016",
    "FRAME_COW1_IDLE_COW1_IDLE_0019": "cow1-idle_0019",
    "FRAME_COW1_IDLE_COW1_IDLE_0018": "cow1-idle_0018",
    "FRAME_COW1_IDLE_COW1_IDLE_0017": "cow1-idle_0017",
    "FRAME_COW1_IDLE_COW1_IDLE_0014": "cow1-idle_0014",
    "FRAME_COW1_IDLE_COW1_IDLE_0013": "cow1-idle_0013",
    "FRAME_COW1_IDLE_COW1_IDLE_0012": "cow1-idle_0012",
    "FRAME_COW1_IDLE_COW1_IDLE_0011": "cow1-idle_0011",
    "FRAME_COW1_JUMP_COW1_JUMP_0000": "cow1-jump_0000",
    "FRAME_COW1_JUMP_COW1_JUMP_0001": "cow1-jump_0001",
    "FRAME_COW1_JUMP_COW1_JUMP_0002": "cow1-jump_0002",
    "FRAME_COW1_JUMP_COW1_JUMP_0003": "cow1-jump_0003",
    "FRAME_COW1_JUMP_COW1_JUMP_0004": "cow1-jump_0004",
    "FRAME_COW1_JUMP_COW1_JUMP_0005": "cow1-jump_0005",
    "FRAME_COW1_JUMP_COW1_JUMP_0006": "cow1-jump_0006",
    "FRAME_COW1_JUMP_COW1_JUMP_0007": "cow1-jump_0007",
    "FRAME_COW1_JUMP_COW1_JUMP_0008": "cow1-jump_0008",
    "FRAME_COW1_JUMP_COW1_JUMP_0009": "cow1-jump_0009",
    "FRAME_COW1_JUMP_COW1_JUMP_0010": "cow1-jump_0010",
    "FRAME_COW1_JUMP_COW1_JUMP_0011": "cow1-jump_0011",
    "FRAME_COW1_JUMP_COW1_JUMP_0012": "cow1-jump_0012",
    "FRAME_COW1_JUMP_COW1_JUMP_0013": "cow1-jump_0013",
    "FRAME_COW1_JUMP_COW1_JUMP_0014": "cow1-jump_0014",
    "FRAME_COW1_JUMP_COW1_JUMP_0015": "cow1-jump_0015",
    "FRAME_COW1_JUMP_COW1_JUMP_0019": "cow1-jump_0019",
    "FRAME_COW1_JUMP_COW1_JUMP_0018": "cow1-jump_0018",
    "FRAME_COW1_JUMP_COW1_JUMP_0017": "cow1-jump_0017",
    "FRAME_COW1_JUMP_COW1_JUMP_0016": "cow1-jump_0016",
    "FRAME_COW2_IDLE_COW2_IDLE_0000": "cow2-idle_0000",
    "FRAME_COW2_IDLE_COW2_IDLE_0001": "cow2-idle_0001",
    "FRAME_COW2_IDLE_COW2_IDLE_0002": "cow2-idle_0002",
    "FRAME_COW2_IDLE_COW2_IDLE_0003": "cow2-idle_0003",
    "FRAME_COW2_IDLE_COW2_IDLE_0004": "cow2-idle_0004",
    "FRAME_COW2_IDLE_COW2_IDLE_0005": "cow2-idle_0005",
    "FRAME_COW2_IDLE_COW2_IDLE_0006": "cow2-idle_0006",
    "FRAME_COW2_IDLE_COW2_IDLE_0007": "cow2-idle_0007",
    "FRAME_COW2_IDLE_COW2_IDLE_0008": "cow2-idle_0008",
    "FRAME_COW2_IDLE_COW2_IDLE_0009": "cow2-idle_0009",
    "FRAME_COW2_IDLE_COW2_IDLE_0010": "cow2-idle_0010",
    "FRAME_COW2_IDLE_COW2_IDLE_0015": "cow2-idle_0015",
    "FRAME_COW2_IDLE_COW2_IDLE_0016": "cow2-idle_0016",
    "FRAME_COW2_IDLE_COW2_IDLE_0019": "cow2-idle_0019",
    "FRAME_COW2_IDLE_COW2_IDLE_0018": "cow2-idle_0018",
    "FRAME_COW2_IDLE_COW2_IDLE_0017": "cow2-idle_0017",
    "FRAME_COW2_IDLE_COW2_IDLE_0014": "cow2-idle_0014",
    "FRAME_COW2_IDLE_COW2_IDLE_0013": "cow2-idle_0013",
    "FRAME_COW2_IDLE_COW2_IDLE_0012": "cow2-idle_0012",
    "FRAME_COW2_IDLE_COW2_IDLE_0011": "cow2-idle_0011",
    "FRAME_COW2_JUMP_COW2_JUMP_0000": "cow2-jump_0000",
    "FRAME_COW2_JUMP_COW2_JUMP_0001": "cow2-jump_0001",
    "FRAME_COW2_JUMP_COW2_JUMP_0002": "cow2-jump_0002",
    "FRAME_COW2_JUMP_COW2_JUMP_0003": "cow2-jump_0003",
    "FRAME_COW2_JUMP_COW2_JUMP_0004": "cow2-jump_0004",
    "FRAME_COW2_JUMP_COW2_JUMP_0005": "cow2-jump_0005",
    "FRAME_COW2_JUMP_COW2_JUMP_0006": "cow2-jump_0006",
    "FRAME_COW2_JUMP_COW2_JUMP_0007": "cow2-jump_0007",
    "FRAME_COW2_JUMP_COW2_JUMP_0008": "cow2-jump_0008",
    "FRAME_COW2_JUMP_COW2_JUMP_0009": "cow2-jump_0009",
    "FRAME_COW2_JUMP_COW2_JUMP_0010": "cow2-jump_0010",
    "FRAME_COW2_JUMP_COW2_JUMP_0011": "cow2-jump_0011",
    "FRAME_COW2_JUMP_COW2_JUMP_0012": "cow2-jump_0012",
    "FRAME_COW2_JUMP_COW2_JUMP_0013": "cow2-jump_0013",
    "FRAME_COW2_JUMP_COW2_JUMP_0014": "cow2-jump_0014",
    "FRAME_COW2_JUMP_COW2_JUMP_0015": "cow2-jump_0015",
    "FRAME_COW2_JUMP_COW2_JUMP_0019": "cow2-jump_0019",
    "FRAME_COW2_JUMP_COW2_JUMP_0018": "cow2-jump_0018",
    "FRAME_COW2_JUMP_COW2_JUMP_0017": "cow2-jump_0017",
    "FRAME_COW2_JUMP_COW2_JUMP_0016": "cow2-jump_0016",
    "FRAME_GAME_BITMAP": "bitmap",
    "FRAME_GAME_POPUP_BOX": "popup_box",
    "FRAME_GAME_GIFT_BOX_CLOSED": "gift_box_closed",
    "FRAME_GAME_GIFT_OPENED": "gift_opened",
    "FRAME_GAME_VAN1": "van1",
    "FRAME_GAME_VAN2": "van2",
    "FRAME_GAME_VAN3": "van3",
    "FRAME_GAME_VAN4": "van4",
    "FRAME_GAME_SHOP_ICON1": "shop_icon1",
    "FRAME_GAME_SHOP_ICON2": "shop_icon2",
    "FRAME_GAME_SHOP_ICON3": "shop_icon3",
    "FRAME_GAME_SHOP_ICON4": "shop_icon4",
    "FRAME_GAME_SHOP_ICON5": "shop_icon5",
    "FRAME_GAME_SHOP_ICON6": "shop_icon6",
    "FRAME_GAME_SHOP_ICON7": "shop_icon7",
    "FRAME_GAME_SHOP_ICON8": "shop_icon8",
    "FRAME_GAME_CHIC1_ICON1": "chic1_icon1",
    "FRAME_GAME_CHIC1_ICON1B": "chic1_icon1b",
    "FRAME_GAME_CHIC1_ICON2B": "chic1_icon2b",
    "FRAME_GAME_CHIC1_ICON3B": "chic1_icon3b",
    "FRAME_GAME_CHIC2_ICON1": "chic2_icon1",
    "FRAME_GAME_CHIC2_ICON1B": "chic2_icon1b",
    "FRAME_GAME_CHIC2_ICON2B": "chic2_icon2b",
    "FRAME_GAME_CHIC2_ICON3B": "chic2_icon3b",
    "FRAME_GAME_CHIC3_ICON1": "chic3_icon1",
    "FRAME_GAME_CHIC3_ICON1B": "chic3_icon1b",
    "FRAME_GAME_CHIC3_ICON2B": "chic3_icon2b.png",
    "FRAME_GAME_CHIC3_ICON3B": "chic3_icon3b.png",
    "FRAME_GAME_COW1_ICON1": "cow1_icon1",
    "FRAME_GAME_COW1_ICON2": "cow1_icon2",
    "FRAME_GAME_COW1_ICON3": "cow1_icon3",
    "FRAME_GAME_COW2_ICON1": "cow2_icon1",
    "FRAME_GAME_COW2_ICON2": "cow2_icon2",
    "FRAME_GAME_COW2_ICON3": "cow2_icon3",
    "FRAME_GAME_GOAT1_ICON1": "goat1_icon1",
    "FRAME_GAME_GOAT1_ICON2": "goat1_icon2",
    "FRAME_GAME_GOAT1_ICON3": "goat1_icon3",
    "FRAME_GAME_GOAT2_ICON1": "goat2_icon1",
    "FRAME_GAME_GOAT2_ICON2": "goat2_icon2",
    "FRAME_GAME_GOAT2_ICON3": "goat2_icon3",
    "FRAME_GAME_BOARD2": "board2",
    "FRAME_GAME_ROUNDED_RECT": "rounded_rect",
    "FRAME_GAME_SPEECH_BUBBLE": "speech_bubble",
    "FRAME_GAME_COOKIELIGHT": "cookielight",
    "FRAME_GAME_FARM_ICON": "farm_icon",
    "FRAME_GAME_CASH_BUNDLE": "cash_bundle",
    "FRAME_GAME_QUESTION_BOARD_ICON": "question_board)icon",
    "FRAME_GAME_TRAY_BACK": "tray_back",
    "FRAME_GAME_TRAY_FRONT": "tray_front",
    "FRAME_GAME_CASH": "cash",
    "FRAME_GAME_VIDEOADICON": "videoadicon",
    "FRAME_GAME_MILK_BOTTLE": "milk_bottle",
    "FRAME_GAME_BTN_BASE1": "btn_base1",
    "FRAME_GAME_BTN_BASE2": "btn_base2",
    "FRAME_GAME_BTN_BASE3": "btn_base3",
    "FRAME_GAME_ARROW": "arrow",
    "FRAME_GAME_TRAY_FOOD": "tray_food",
    "FRAME_GAME_TRAY_WATER": "tray_water",
    "FRAME_GAME_UPGRADE_ICON_AD": "upgrade_icon_ad",
    "FRAME_GAME_BOARD_STICK": "board_stick",
    "FRAME_GAME_HELPER_DP": "helper_dp",
    "FRAME_GAME_RING": "ring",
    "FRAME_GAME_BARN_DP": "barn_dp",
    "FRAME_GAME_DOLLAR_ICON": "dollar_icon",
    "FRAME_GAME_UPGRADE_ICON": "upgrade_icon",
    "FRAME_GAME_MANAGER_DP": "manager_dp",
    "FRAME_GAME_OBJECTIVES_BTN": "objectives_btn",
    "FRAME_GAME_DUST": "dust",
    "FRAME_GAME_ELLIPSE_LINE": "ellipse-line",
    "FRAME_GAME_WHITE_SQUARE": "white-square",
    "FRAME_GAME_EGG1_NOSHADOW": "egg1_noshadow",
    "FRAME_GAME_EGG2_NOSHADOW": "egg2_noshadow",
    "FRAME_GAME_EGG3_NOSHADOW": "egg3_noshadow",
    "FRAME_GAME_EGG_0001": "egg_0001",
    "FRAME_GAME_EGG_0002": "egg_0002",
    "FRAME_GAME_EGG_0003": "egg_0003",
    "FRAME_GAME_EXCLAMATION": "exclamation",
    "FRAME_GAME_TITLE_ICON_CHIC": "title_icon_chic",
    "FRAME_GAME_EGG": "egg",
    "FRAME_GAME_SPEECH_BUBBLE_POINTER": "speech_bubble_pointer",
    "FRAME_GAME_DOT": "dot",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_00": "goat1_idle_00",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_01": "goat1_idle_01",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_02": "goat1_idle_02",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_03": "goat1_idle_03",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_04": "goat1_idle_04",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_05": "goat1_idle_05",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_06": "goat1_idle_06",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_07": "goat1_idle_07",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_08": "goat1_idle_08",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_09": "goat1_idle_09",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_10": "goat1_idle_10",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_15": "goat1_idle_15",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_16": "goat1_idle_16",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_19": "goat1_idle_19",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_18": "goat1_idle_18",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_17": "goat1_idle_17",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_14": "goat1_idle_14",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_13": "goat1_idle_13",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_12": "goat1_idle_12",
    "FRAME_GOAT1_IDLE_GOAT1_IDLE_11": "goat1_idle_11",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_00": "goat1_jump_00",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_01": "goat1_jump_01",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_02": "goat1_jump_02",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_03": "goat1_jump_03",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_04": "goat1_jump_04",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_05": "goat1_jump_05",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_06": "goat1_jump_06",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_07": "goat1_jump_07",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_08": "goat1_jump_08",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_09": "goat1_jump_09",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_10": "goat1_jump_10",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_11": "goat1_jump_11",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_12": "goat1_jump_12",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_13": "goat1_jump_13",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_14": "goat1_jump_14",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_15": "goat1_jump_15",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_19": "goat1_jump_19",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_18": "goat1_jump_18",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_17": "goat1_jump_17",
    "FRAME_GOAT1_JUMP_GOAT1_JUMP_16": "goat1_jump_16",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_00": "goat2_idle_00",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_01": "goat2_idle_01",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_02": "goat2_idle_02",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_03": "goat2_idle_03",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_04": "goat2_idle_04",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_05": "goat2_idle_05",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_06": "goat2_idle_06",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_07": "goat2_idle_07",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_08": "goat2_idle_08",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_09": "goat2_idle_09",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_10": "goat2_idle_10",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_15": "goat2_idle_15",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_16": "goat2_idle_16",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_19": "goat2_idle_19",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_18": "goat2_idle_18",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_17": "goat2_idle_17",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_14": "goat2_idle_14",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_13": "goat2_idle_13",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_12": "goat2_idle_12",
    "FRAME_GOAT2_IDLE_GOAT2_IDLE_11": "goat2_idle_11",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_00": "goat2_jump_00",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_01": "goat2_jump_01",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_02": "goat2_jump_02",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_03": "goat2_jump_03",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_04": "goat2_jump_04",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_05": "goat2_jump_05",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_06": "goat2_jump_06",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_07": "goat2_jump_07",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_08": "goat2_jump_08",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_09": "goat2_jump_09",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_10": "goat2_jump_10",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_11": "goat2_jump_11",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_12": "goat2_jump_12",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_13": "goat2_jump_13",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_14": "goat2_jump_14",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_15": "goat2_jump_15",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_19": "goat2_jump_19",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_18": "goat2_jump_18",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_17": "goat2_jump_17",
    "FRAME_GOAT2_JUMP_GOAT2_JUMP_16": "goat2_jump_16",
    "FRAME_HELPER_WALK_HELPER_WALK_0001": "helper_walk_0001",
    "FRAME_HELPER_WALK_HELPER_WALK_0002": "helper_walk_0002",
    "FRAME_HELPER_WALK_HELPER_WALK_0003": "helper_walk_0003",
    "FRAME_HELPER_WALK_HELPER_WALK_0004": "helper_walk_0004",
    "FRAME_HELPER_WALK_HELPER_WALK_0005": "helper_walk_0005",
    "FRAME_HELPER_WALK_HELPER_WALK_0006": "helper_walk_0006",
    "FRAME_HELPER_WALK_HELPER_WALK_0007": "helper_walk_0007",
    "FRAME_HELPER_WALK_HELPER_WALK_0008": "helper_walk_0008",
    "FRAME_HELPER_WALK_HELPER_WALK_0009": "helper_walk_0009",
    "FRAME_HELPER_WALK_HELPER_WALK_0010": "helper_walk_0010",
    "FRAME_HELPER_WALK_HELPER_WALK_0011": "helper_walk_0011",
    "FRAME_HELPER_WALK_HELPER_WALK_0012": "helper_walk_0012",
    "FRAME_HELPER_WALK_HELPER_WALK_0013": "helper_walk_0013",
    "FRAME_HELPER_WALK_HELPER_WALK_0014": "helper_walk_0014",
    "FRAME_HELPER_WALK_HELPER_WALK_0015": "helper_walk_0015",
    "FRAME_HELPER_WALK_HELPER_WALK_0016": "helper_walk_0016",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_00": "goat_kid1_idle_00",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_01": "goat_kid1_idle_01",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_02": "goat_kid1_idle_02",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_03": "goat_kid1_idle_03",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_04": "goat_kid1_idle_04",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_05": "goat_kid1_idle_05",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_06": "goat_kid1_idle_06",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_07": "goat_kid1_idle_07",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_08": "goat_kid1_idle_08",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_09": "goat_kid1_idle_09",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_10": "goat_kid1_idle_10",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_12": "goat_kid1_idle_12",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_13": "goat_kid1_idle_13",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_14": "goat_kid1_idle_14",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_19": "goat_kid1_idle_19",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_18": "goat_kid1_idle_18",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_17": "goat_kid1_idle_17",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_16": "goat_kid1_idle_16",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_15": "goat_kid1_idle_15",
    "FRAME_KID1_IDLE_GOAT_KID1_IDLE_11": "goat_kid1_idle_11",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_00": "goat_kid1_jump_00",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_01": "goat_kid1_jump_01",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_02": "goat_kid1_jump_02",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_03": "goat_kid1_jump_03",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_04": "goat_kid1_jump_04",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_05": "goat_kid1_jump_05",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_06": "goat_kid1_jump_06",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_07": "goat_kid1_jump_07",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_08": "goat_kid1_jump_08",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_09": "goat_kid1_jump_09",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_10": "goat_kid1_jump_10",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_13": "goat_kid1_jump_13",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_14": "goat_kid1_jump_14",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_15": "goat_kid1_jump_15",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_19": "goat_kid1_jump_19",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_18": "goat_kid1_jump_18",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_17": "goat_kid1_jump_17",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_16": "goat_kid1_jump_16",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_12": "goat_kid1_jump_12",
    "FRAME_KID1_JUMP_GOAT_KID1_JUMP_11": "goat_kid1_jump_11",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_00": "goat_kid2_idle_00",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_01": "goat_kid2_idle_01",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_02": "goat_kid2_idle_02",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_03": "goat_kid2_idle_03",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_04": "goat_kid2_idle_04",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_05": "goat_kid2_idle_05",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_06": "goat_kid2_idle_06",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_07": "goat_kid2_idle_07",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_08": "goat_kid2_idle_08",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_09": "goat_kid2_idle_09",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_10": "goat_kid2_idle_10",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_12": "goat_kid2_idle_12",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_13": "goat_kid2_idle_13",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_14": "goat_kid2_idle_14",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_15": "goat_kid2_idle_15",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_19": "goat_kid2_idle_19",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_18": "goat_kid2_idle_18",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_17": "goat_kid2_idle_17",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_16": "goat_kid2_idle_16",
    "FRAME_KID2_IDLE_GOAT_KID2_IDLE_11": "goat_kid2_idle_11",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_00": "goat_kid2_jump_00",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_01": "goat_kid2_jump_01",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_02": "goat_kid2_jump_02",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_03": "goat_kid2_jump_03",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_04": "goat_kid2_jump_04",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_05": "goat_kid2_jump_05",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_06": "goat_kid2_jump_06",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_07": "goat_kid2_jump_07",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_08": "goat_kid2_jump_08",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_09": "goat_kid2_jump_09",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_10": "goat_kid2_jump_10",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_13": "goat_kid2_jump_13",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_14": "goat_kid2_jump_14",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_15": "goat_kid2_jump_15",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_19": "goat_kid2_jump_19",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_18": "goat_kid2_jump_18",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_17": "goat_kid2_jump_17",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_16": "goat_kid2_jump_16",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_12": "goat_kid2_jump_12",
    "FRAME_KID2_JUMP_GOAT_KID2_JUMP_11": "goat_kid2_jump_11",
    "FRAME_LOADER_GRASS": "grass",
    "FRAME_LOW_HEALTH_EFFECT_LOW_HEALTH_0001": "low_health_0001",
    "FRAME_LOW_HEALTH_EFFECT_LOW_HEALTH_0002": "low_health_0002",
    "FRAME_LOW_HEALTH_EFFECT_LOW_HEALTH_0003": "low_health_0003",
    "FRAME_LOW_HEALTH_EFFECT_LOW_HEALTH_0004": "low_health_0004",
    "FRAME_LOW_HEALTH_EFFECT_LOW_HEALTH_0005": "low_health_0005",
    "FRAME_LOW_HEALTH_EFFECT_LOW_HEALTH_0006": "low_health_0006",
    "FRAME_LOW_HEALTH_EFFECT_LOW_HEALTH_0007": "low_health_0007",
    "FRAME_LOW_HEALTH_EFFECT_LOW_HEALTH_0008": "low_health_0008",
    "FRAME_LOW_HEALTH_EFFECT_LOW_HEALTH_0009": "low_health_0009",
    "FRAME_LOW_HEALTH_EFFECT_LOW_HEALTH_0010": "low_health_0010",
    "FRAME_LOW_HEALTH_EFFECT_LOW_HEALTH_0011": "low_health_0011",
    "FRAME_LOW_HEALTH_EFFECT_LOW_HEALTH_0012": "low_health_0012",
    "FRAME_LOW_HEALTH_EFFECT_LOW_HEALTH_0013": "low_health_0013",
    "FRAME_LOW_HEALTH_EFFECT_LOW_HEALTH_0014": "low_health_0014",
    "FRAME_POINTER_POINTER_0001": "pointer_0001",
    "FRAME_POINTER_POINTER_0002": "pointer_0002",
    "FRAME_POINTER_POINTER_0003": "pointer_0003",
    "FRAME_POINTER_POINTER_0004": "pointer_0004",
    "FRAME_POINTER_POINTER_0005": "pointer_0005",
    "FRAME_POINTER_POINTER_0006": "pointer_0006",
    "FRAME_POINTER_POINTER_0007": "pointer_0007",
    "FRAME_POINTER_POINTER_0008": "pointer_0008",
    "FRAME_POINTER_POINTER_0009": "pointer_0009",
    "FRAME_POINTER_POINTER_0010": "pointer_0010",
    "FRAME_POINTER_POINTER_0011": "pointer_0011",
    "FRAME_POINTER_POINTER_0012": "pointer_0012",
    "FRAME_POINTER_POINTER_0013": "pointer_0013",
    "FRAME_POINTER_POINTER_0014": "pointer_0014",
    "FRAME_TILESET_BARN": "barn",
    "FRAME_TILESET_NOTICE_BOARD": "notice-board",
    "FRAME_TILESET_GRASS": "grass",
    "FRAME_TILESET_LAND": "land",
    "FRAME_TILESET_ROAD_B_GRASS": "road-b-grass",
    "FRAME_TILESET_ROAD_L_GRASS": "road-l-grass",
    "FRAME_TILESET_ROAD_R_GRASS": "road-r-grass",
    "FRAME_TILESET_ROAD_T_GRASS": "road-t-grass",
    "FRAME_TILESET_ROADJN_BL": "roadjn-bl",
    "FRAME_TILESET_ROADJN_BR": "roadjn-br",
    "FRAME_TILESET_ROADJN_TL": "roadjn-tl",
    "FRAME_TILESET_ROADJN_TR": "roadjn-tr",
    "FRAME_TILESET_SAND_B_GRASS": "sand-b-grass",
    "FRAME_TILESET_SAND_L_GRASS": "sand-l-grass",
    "FRAME_TILESET_SAND_LB_GRASS": "sand-lb-grass",
    "FRAME_TILESET_SAND_LT_GRASS": "sand-lt-grass",
    "FRAME_TILESET_SAND_R_GRASS": "sand-r-grass",
    "FRAME_TILESET_SAND_RB_GRASS": "sand-rb-grass",
    "FRAME_TILESET_SAND_RT_GRASS": "sand-rt-grass",
    "FRAME_TILESET_SAND_T_GRASS": "sand-t-grass",
    "FRAME_TILESET_TREE1": "tree1",
    "FRAME_TILESET_TREE2": "tree2",
    "FRAME_TILESET_TREE3": "tree3",
    "FRAME_TILESET_TREE4": "tree4",
    "FRAME_TILESET_TREE5": "tree5",
    "FRAME_TILESET_STONE1": "stone1",
    "FRAME_TILESET_STONE3": "stone3",
    "FRAME_TILESET_STONE2": "stone2",
    "FRAME_TILESET_STONE4": "stone4",
    "FRAME_UI_POPUP_BOX": "popup_box",
    "FRAME_UI_BTN_BASE_BLUE": "btn_base_blue",
    "FRAME_UI_BTN_BASE_GREEN": "btn_base_green",
    "FRAME_UI_BTN_BASE_ORANGE": "btn_base_orange",
    "FRAME_UI_BTN_BASE_RED": "btn_base_red",
    "FRAME_UI_GIFT_AD_BUTTON_BG": "gift_ad_button_bg",
    "FRAME_UI_GIFT_AD_BUTTON_SHINE": "gift_ad_button_shine",
    "FRAME_UI_POPUP_INNER_BOX": "popup_inner_box",
    "FRAME_UI_DOUBLE_SPEED_ICON": "double_speed_icon",
    "FRAME_UI_INVESTOR_ICON": "investor_icon",
    "FRAME_UI_BTN_SOUNDOFF": "btn_soundoff",
    "FRAME_UI_BTN_SOUNDON": "btn_soundon",
    "AUDIOSPRITE_SOUNDS": {
        "type": "AUDIOSPRITE",
        "key": "AUDIOSPRITE_SOUNDS",
        "urls": [
            "assets/sounds/sounds.mp3"
        ],
        "jsonUrl": "assets/sounds/sounds.json"
    },
    "AUDIOSPRITE_MARKER_SILENCE": "silence",
    "AUDIOSPRITE_MARKER_CLICK": "click",
    "AUDIOSPRITE_MARKER_COINSHAKE": "coinshake",
    "AUDIOSPRITE_MARKER_COLLECT": "collect",
    "AUDIOSPRITE_MARKER_EXCLAMATION": "exclamation",
    "AUDIOSPRITE_MARKER_FILL": "fill",
    "AUDIOSPRITE_MARKER_GIFTPOPUP": "giftpopup",
    "AUDIOSPRITE_MARKER_POSITIVE1": "positive1",
    "AUDIOSPRITE_MARKER_POSITIVE2": "positive2",
    "AUDIOSPRITE_MARKER_POSITIVE3": "positive3",
    "AUDIOSPRITE_MARKER_POSITIVE4": "positive4",
    "AUDIOSPRITE_MARKER_POSITIVE5": "positive5",
    "AUDIOSPRITE_MARKER_TASK_SUCCESSFUL": "task_successful",
    "AUDIOSPRITE_MARKER_WOOP": "woop",
    "OTHER_MAP": {
        "type": "OTHER_JSON",
        "key": "OTHER_MAP",
        "url": "assets/other/map.json"
    }
}